[
  {
    "id": "efficient",
    "label": "Efficient",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-efficient"
  },
  {
    "id": "flexible",
    "label": "Flexible",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-flexible"
  },
  {
    "id": "maintainable",
    "label": "Maintainable",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-maintainable"
  },
  {
    "id": "operable",
    "label": "Operable",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-operable"
  },
  {
    "id": "reliable",
    "label": "Reliable",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-reliable"
  },
  {
    "id": "safe",
    "label": "Safe",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-safe"
  },
  {
    "id": "secure",
    "label": "Secure",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-secure"
  },
  {
    "id": "suitable",
    "label": "Suitable",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-suitable"
  },
  {
    "id": "usable",
    "label": "Usable",
    "size": 35,
    "color": "#1a3a5c",
    "textColor": "#c8e6f5",
    "qualityType": "dimension",
    "page": "/tag-usable"
  }
]